<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading" :opacity="1.0"></loading>
    <MainHeader @signOut="signOut"/>
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from 'vuex'
import MainHeader from './components/MainHeader';
import Footer from './components/Footer.vue'
import {generateManifestDataUrl} from './utils/manifestGenerator'

export default {
  name: 'App',
  components: {
    Loading,
    MainHeader,
    Footer
  },
  computed: {
    ...mapState([
      'isLoading',
    ])
  },
  methods: {
    signOut () {
      this.$http.secured.delete('/attendee_api/v1/signout')
        .then(() => {
          delete localStorage.csrf
          delete localStorage.signedIn
          this.$router.replace('/signin')
         })
         .catch(error => this.setError(error, 'Cannot sign out'))
    }
  },
  watch: {
    '$store.state.attendee': {
      handler() {
        const newEvent = this.$store.state.event
        console.log("BBB")
        const isMobile = () => {
          const minWidth = 768; // Minimum width for desktop devices
          return window.innerWidth < minWidth || screen.width < minWidth;
        }

        if (newEvent && newEvent.name && isMobile() && (window.location.href.includes('localhost') || window.location.href.includes('attendee2'))) {
          document.querySelector('link[rel="manifest"]').setAttribute('href', generateManifestDataUrl(newEvent))
          document.querySelector('meta[name="apple-mobile-web-app-title"]').setAttribute('content', newEvent.name)

          console.log("AAA", newEvent.name)

          window.AddToHomeScreenInstance = window.AddToHomeScreen({
            appName: newEvent.name,                                   // Name of the app.
                                                                  // Required.
            appNameDisplay: 'standalone',                          // If set to 'standalone' (the default), the app name will be diplayed
                                                                  // on it's own, beneath the "Install App" header. If set to 'inline', the
                                                                  // app name will be displayed on a single line like "Install MyApp"
                                                                  // Optional. Default 'standalone'
            appIconUrl: (window.location.origin + require("@/assets/images/logos/forum-events-180.png")),                    // App icon link (square, at least 40 x 40 pixels).
                                                                  // Required.
            assetUrl: 'https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@2.98/dist/assets/img/',  // Link to directory of library image assets.

            maxModalDisplayCount: 1,                               // If set, the modal will only show this many times.
                                                                  // Optional. Default: -1 (no limit).  (Debugging: Use this.clearModalDisplayCount() to reset the count)
            displayOptions: {
              showMobile: true,
              showDesktop: true
            },

            allowClose: true // allow the user to close the modal by tapping outside of it [Optional. Default: true]
          });

          setTimeout(() => {
            window.AddToHomeScreenInstance.show('en')
          }, 5000)
        }
      },
      immediate: true
    }
  },
  created() {
    if ('serviceWorker' in navigator && (window.location.href.includes('localhost') || window.location.href.includes('attendee2'))) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
          .then(registration => {
            console.log('ServiceWorker registration successful:', registration.scope)
          })
          .catch(error => {
            console.log('ServiceWorker registration failed:', error)
          })
      })
    }
  },
}
</script>

<style>
</style>
